.questionMarkers {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.fileList {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.autoGeneratedIssueContainer {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: baseline;
}
